<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100"
  >
    <video class="video-bg" id="video-element1" autoplay muted loop>
      <source
        src="~@/assets/images/pages/login/BG_Login.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content-login">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="position-relative w-100 h-100 text-center mt-2 mb-1">
              <img
                :src="forgetPasswordImg"
                alt="forgetPasswordImg"
                width="200"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="font-large-1 text-bold text-black text-center m-1">
              Forgot Password
            </div>
          </div>
          <div class="col-12 mb-1">
            <div class="font-medium-5 text-black text-center">
              Enter your email below and we’ll email you with
            </div>
            <div class="font-medium-5 text-black text-center">
              instructions on how to reset your password.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="m-auto">
              <b-form id="forget-password" @submit.prevent="onSubmit">
                <div class="add-on-border-group mt-10px w-100">
                  <div class="position-relative w-70 m-auto">
                    <b-input-group
                      class="input-group-merge input-group-border w-80 m-auto"
                      :class="[formError.email == true ? 'error' : '']"
                    >
                      <b-input-group-prepend is-text class="add-on-border">
                        <email-svg class="icon-email-svg" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="formData.email"
                        placeholder="Your Email"
                        class="add-on-border-input"
                        id="input-email"
                        name="input-email"
                        @input="onInputEmail"
                      />
                    </b-input-group>
                  </div>

                  <div class="add-on-border-group text-error-area">
                    <div class="position-relative w-70 m-auto">
                      <div
                        class="text-danger text-bold font-medium-5"
                        v-if="formError.email"
                      >
                        <div class="d-flex justify-start align-items-center">
                          <div class="mr-1">
                            <feather-icon icon="AlertCircleIcon" size="1x" />
                          </div>
                          <div>{{ formError.errorMessage }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="m-3 text-center">
                  <div class="w-80 m-auto">
                    <b-button
                      type="submit"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      :disabled="!formData.email"
                      class="w-80"
                      ><div class="font-medium-5">Send</div>
                    </b-button>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright mt-1 mb-1">
      <img :src="logoChoco" width="150" class="logo-choco" />
    </div>
  </div>
</template>

<script>
import VuexyLogo from "@core/layouts/components/Logo.vue";
import EmailSvg from "@/@core/components/svg/common/EmailOpen.vue";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import forgetPasswordImg from "@/assets/images/pages/forgor-password/Forgot-Mail-BP.png";
import emailImg from "@/assets/images/pages/forgor-password/Forgot-mail1-BP.png";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  ref,
  watch,
} from "@vue/composition-api";

export default {
  directives: {
    Ripple,
  },
  props: { errorMessage: null },
  components: {
    VuexyLogo,
    EmailSvg,
    vSelect,
  },

  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;
    const formData = reactive({
      email: null,
    });

    const formError = reactive({
      email: false,
      errorMessage: "กรอกอีเมลไม่ถูกต้อง",
    });

    const onInputEmail = () => {
      formError.email = false;
    };

    const ValidateEmailAddress = (emailString) => {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return (
        !!emailString &&
        typeof emailString === "string" &&
        emailString.match(emailRegex)
      );
    };

    const CheckEmail = (emailString) => {
      //get result as true/false
      var result = ValidateEmailAddress(emailString);
      if (result) return true;
      else return false;
    };

    const onSubmit = () => {
      if (!CheckEmail(formData.email)) {
        formError.email = true;
        formError.errorMessage = "กรอกอีเมลไม่ถูกต้อง";
      } else {
        emit("onNextStep", formData.email);
      }
    };

    watch(
      () => props,
      () => {
        if (props.errorMessage) {
          formError.email = true;
          formError.errorMessage = props.errorMessage;
        }
      },
      { deep: true }
    );

    return {
      formData,
      formError,
      logoChoco,
      emailImg,
      forgetPasswordImg,
      ValidateEmailAddress,
      onSubmit,
      onInputEmail,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.content-login {
  width: 700px;
  height: auto;
  display: flex;
  /* overflow: hidden; */
  z-index: 1;
}

.input-group-border {
  border-radius: 8px;
}

.input-group:not(.bootstrap-touchspin):focus-within .form-control,
.input-group:not(.bootstrap-touchspin):focus-within .input-group-text {
  /* border-color: unset !important; */
}

.input-group.error .form-control,
.input-group.error .input-group-text {
  border-color: red !important;
  /* color: red !important; */
}

.input-group.error svg {
  fill: red !important;
}

.text-error-area {
  margin-top: 5px;
}
</style>
